export default __webpack_public_path__ + "static/media/label-thumbnail.1b6774b8.jpg";